var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7,44.9L34.1,31.2c2.6-3.2,4.2-7.4,4.2-11.9c0-10.5-8.5-19-19-19s-19,8.5-19,19s8.5,19,19,19c4.5,0,8.7-1.6,11.9-4.2 l13.7,13.7L47.7,44.9z M2.3,19.3c0-9.4,7.6-17,17-17s17,7.6,17,17c0,4.5-1.8,8.6-4.7,11.7L31,31.6c-3,2.9-7.2,4.7-11.7,4.7 C9.9,36.3,2.3,28.7,2.3,19.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.7272c9ff42f2440af5b48e5d0136bd72.svg";
export { ForwardRef as ReactComponent };